<mat-toolbar>

  @if(!this.activeListsShown) {
    <button mat-stroked-button (click)="getData()" >{{'GENERAL.BACK' | translate | uppercase }}</button>
  } @else {
    <button mat-stroked-button routerLink="/lists/new">{{'GENERAL.NEW' | translate | uppercase }}</button>
    <button mat-stroked-button (click)="getArchivedLists()" >{{'RANKINGLISTS.VIEW_ARCHIVED' | translate | uppercase }}</button>
  }

</mat-toolbar>
<mat-nav-list>
<!--   @if (this.activeListsShown) {
    <div mat-subheader translate>{{'RANKINGLISTS.RANKINGLISTS' | translate }}</div>
  } @else {
    <div mat-subheader translate>{{'RANKINGLISTS.ARCHIVED' | translate | uppercase}}</div>
  } -->

  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    @if (myLists.length > 0) {
    <div mat-subheader translate>{{'RANKINGLISTS.MY_LISTS' | translate }}</div>
    @for (list of myLists; track list.ListId) {
      <a mat-list-item [routerLink]="['/lists/details', list.ListId]">

        <mat-icon matListItemIcon>format_list_numbered</mat-icon>

        <div matListItemTitle>{{list.Description}}</div>
        @if (!list.Archived) {
          <div matListItemLine>{{list.CreatedByLastName}}, {{list.CreatedByFirstName }}</div>
        }
        @if (!list.Archived) {
          <span>{{list.NumberOfPlayers}} {{'RANKINGLISTS.PLAYERS' | translate | lowercase }}</span>
        }

        @if (list.Archived) {
          <mat-icon color="warn">archive</mat-icon>
        }
      </a>
    }
    <mat-divider></mat-divider>
  }

  @if (otherScoutGroups.length > 0) {
    <div mat-subheader>OTHER SCOUTS</div>
    <mat-accordion class="scout-groups" multi>
      @for (group of otherScoutGroups; track group.scoutName) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ group.scoutName }} ({{ group.lists.length }} lists)</mat-panel-title>
            <!-- <mat-panel-description>{{ group.lists.length }} lists</mat-panel-description> -->
          </mat-expansion-panel-header>

          @for (list of group.lists; track list.ListId) {
            <a mat-list-item [routerLink]="['/lists/details', list.ListId]">

              <mat-icon matListItemIcon>format_list_numbered</mat-icon>

              <div matListItemTitle>{{list.Description}}</div>
              <span>{{list.NumberOfPlayers}} {{'RANKINGLISTS.PLAYERS' | translate | lowercase }}</span>

              @if (list.Archived) {
                <mat-icon color="warn">archive</mat-icon>
              }
            </a>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  }

  @if (myLists.length === 0 && otherScoutGroups.length === 0) {
    <div style="padding: 16px; color: gray;">
      {{'RANKINGLISTS.NOLISTSFOUND' | translate}}
    </div>
  }
  }

</mat-nav-list>
